export default {
  relatedArticles: {
    mediaWrapper: 'mediaWrapper',
    card: {
      card: 'card',
      mainWrapper: {
        generic: 'purple',
        notLastChild: ' pt-40 md:pt-20',
        notLastChildNew: 'md:pt-20',
        lastChild: 'sm:border-0 md:ml-3.5p',
      },

      content: 'content',
      titleWrapper: 'titleWrapper ',
      shortDescription: 'shortDescription',
      media: 'media',
      header:
        'font-BebasNeueRegular sm:mt-10 md:mt-15 block text-18 leading-30 tracking-wider font-bold md:pt-0 gradient-line table md:text-black sm:text-white ',
      button: 'button',
      viewCount: 'viewCount flex',
      eyeIconStyles: 'eyeIconStyles mr-10',
      viewCountWrapper: 'font-HelveticaNeueMedium text-base',
      title:
        'title sm:text-7v tracking-wider11x md:text-26 font-BebasNeueRegular sm:text-white md:text-black pb-5',
      subtitle:
        'title sm:text-7.5v landscape_sm:text-4.5v landscape_small_font md:text-2.7v font-BornreadyRegular sm:text-white md:text-black',
      carouselHeader:
        'carouselHeader w-full text-center font-BornreadyRegular sm:text-9.5v md:text-36 sm:py-30 md:py-36 relative',
    },
  },
  cardOne: {
    mediaWrapper: 'mediaWrapper',
    card: {
      card: 'card',
      mainWrapper: {
        generic: 'pink',
        notLastChild: ' pt-40 md:pt-20',
        notLastChildNew: 'md:pt-20',
        lastChild: 'sm:border-0 md:ml-3.5p',
      },

      content: 'content',
      titleWrapper: 'titleWrapper ',
      shortDescription: 'shortDescription',
      media: 'media',
      header:
        'font-BebasNeueRegular sm:mt-10 md:mt-15 block text-18 leading-30 tracking-wider font-bold md:pt-0 gradient-line table md:text-black sm:text-white ',
      button: 'button',
      viewCount: 'viewCount flex',
      eyeIconStyles: 'eyeIconStyles mr-10',
      viewCountWrapper: 'font-HelveticaNeueMedium text-base',
      title:
        'title sm:text-7v tracking-wider11x  md:text-26 font-BebasNeueRegular sm:text-white md:text-black pb-5',
      subtitle:
        'title sm:text-7.5v landscape_sm:text-4.5v landscape_small_font md:text-2.7v font-BornreadyRegular sm:text-white md:text-black',
      carouselHeader:
        'carouselHeader w-full text-center font-BornreadyRegular sm:text-9.5v md:text-36 sm:py-30 md:py-36 ',
    },
  },
  cardTwo: {
    mediaWrapper: 'mediaWrapper',
    card: {
      card: 'card',
      mainWrapper: {
        generic: 'blue',
        notLastChild: ' pt-40 md:pt-20',
        notLastChildNew: 'md:pt-20',
        lastChild: 'sm:border-0 md:ml-3.5p',
      },

      content: 'content',
      titleWrapper: 'titleWrapper ',
      shortDescription: 'shortDescription',
      media: 'media',
      header:
        'font-BebasNeueRegular sm:mt-10 md:mt-15 block text-18 leading-30 tracking-wider font-bold md:pt-0 gradient-line table md:text-black sm:text-white ',
      button: 'button',
      viewCount: 'viewCount flex',
      eyeIconStyles: 'eyeIconStyles mr-10',
      viewCountWrapper: 'font-HelveticaNeueMedium text-base',
      title:
        'title sm:text-7v tracking-wider11x  md:text-26 font-BebasNeueRegular sm:text-white md:text-black pb-5',
      subtitle:
        'title sm:text-7.5v landscape_sm:text-4.5v landscape_small_font md:text-2.7v font-BornreadyRegular sm:text-white md:text-black',
      carouselHeader:
        'carouselHeader w-full text-center font-BornreadyRegular sm:text-9.5v md:text-36 sm:py-30 md:py-36 ',
    },
  },
  cardThree: {
    mediaWrapper: 'mediaWrapper',
    card: {
      card: 'card',
      mainWrapper: {
        generic: 'grey',
        notLastChild: ' pt-40 md:pt-20',
        notLastChildNew: 'md:pt-20',
        lastChild: 'sm:border-0 md:ml-3.5p',
      },

      content: 'content',
      titleWrapper: 'titleWrapper ',
      shortDescription: 'shortDescription',
      media: 'media',
      header:
        'font-BebasNeueRegular sm:mt-10 md:mt-15 block text-18 leading-30 tracking-wider font-bold md:pt-0 gradient-line table md:text-black sm:text-white ',
      button: 'button',
      viewCount: 'viewCount flex',
      eyeIconStyles: 'eyeIconStyles mr-10',
      viewCountWrapper: 'font-HelveticaNeueMedium text-base',
      title:
        'title sm:text-7v tracking-wider11x  md:text-26 font-BebasNeueRegular sm:text-white md:text-black pb-5',
      subtitle:
        'title sm:text-7.5v landscape_sm:text-4.5v landscape_small_font md:text-2.7v font-BornreadyRegular sm:text-white md:text-black',
      carouselHeader:
        'carouselHeader w-full text-center font-BornreadyRegular sm:text-9.5v md:text-36 sm:py-30 md:py-36 ',
    },
  },
  homeCarouselParent: 'w-full flex flex-wrap',
  homeCarouselCardWidth: 'w-full',
};
